import { getStageState } from "../lib/journey";

// Stage 12 — Closing & signing.
// Final summary card. Shows the seller what they're walking away with
// (sale price minus reasonable closing costs vs the avoided 3% listing fee).
// Future: AI line-checks the settlement statement for overcharges; generates
// a post-sale checklist (utilities, change of address, tax forms).

const TYPICAL_CLOSING_COSTS_PCT = 0.01; // ~1% of sale: title, escrow, transfer tax

export default function ClosingStage({ state, journey, update }) {
  const valData = getStageState(journey, "valuation").data;
  const salePrice = state.data?.sale_price || valData?.range?.midpoint || null;
  const avoidedFee = salePrice ? Math.round(salePrice * 0.03) : null;
  const closingCosts = salePrice ? Math.round(salePrice * TYPICAL_CLOSING_COSTS_PCT) : null;
  const netProceeds = salePrice ? salePrice - closingCosts : null;
  // BrokerApp.jsx tags its journey with verification.relationship:"broker"
  // (the real consumer flow only ever produces self/representing/other) —
  // "you kept the 3% agent fee" is nonsensical framing when a broker is
  // the one viewing this on a managed client's behalf.
  const isBroker = journey.verification?.relationship === "broker";

  return (
    <>
      <div className="s-ai-pill" style={{ marginBottom: 14 }}>
        ★ AI · Coming soon: line-check the settlement statement vs market norms + generate post-sale checklist
      </div>

      <div className="s-soon" style={{ marginBottom: 18 }}>
        <div className="s-soon-row">
          <div className="s-soon-bullet">1</div>
          <div className="s-soon-text"><strong>Final documents.</strong> Deed, settlement statement, transfer disclosures — all DocuSign-ready in your inbox.</div>
        </div>
        <div className="s-soon-row">
          <div className="s-soon-bullet">2</div>
          <div className="s-soon-text"><strong>Wire instructions.</strong> Sale proceeds sent directly to your verified bank account. No listing commission deducted.</div>
        </div>
        <div className="s-soon-row">
          <div className="s-soon-bullet">3</div>
          <div className="s-soon-text"><strong>Keys & possession.</strong> We coordinate the handoff with the buyer's side. You walk away with your equity intact.</div>
        </div>
      </div>

      {salePrice && (
        <>
          {/* Hero */}
          <div style={{ background: "linear-gradient(135deg, #0e2218 0%, #1c4535 100%)", borderRadius: 18, padding: "28px 24px", marginBottom: 14, textAlign: "center" }}>
            <div style={{ fontFamily: "'DM Mono',monospace", fontSize: 10, color: "#7ecfb0", letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 10 }}>
              {isBroker ? "Net proceeds to client" : "Listing commission you kept"}
            </div>
            <div style={{ fontFamily: "'Playfair Display',serif", fontSize: 52, fontWeight: 700, color: "#7ecfb0", lineHeight: 1, marginBottom: 6 }}>
              ${(isBroker ? netProceeds : avoidedFee).toLocaleString()}
            </div>
            {!isBroker && (
              <div style={{ fontFamily: "'DM Mono',monospace", fontSize: 11, color: "#4a9a7a", letterSpacing: "0.06em" }}>
                3% agent fee — eliminated
              </div>
            )}
          </div>

          {/* Secondary card */}
          <div className="s-val-card">
            <div style={{ fontFamily: "'DM Mono',monospace", fontSize: 10, color: "#2d7a62", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 6 }}>
              {isBroker ? "Sale summary" : "Net proceeds to you"}
            </div>
            <div className="s-val-range">{isBroker ? `$${salePrice.toLocaleString()}` : `$${netProceeds.toLocaleString()}`}</div>
            <div style={{ fontSize: 12, color: "#5b7365", marginTop: 8, lineHeight: 1.6 }}>
              Sale price ${salePrice.toLocaleString()} − ~1% closing costs ${closingCosts.toLocaleString()}
            </div>
          </div>
        </>
      )}
    </>
  );
}
